import * as React from 'react'

import { ResourceEditRecord } from '~/client/src/shared/components/ResourceViewEdit/ResourceEditContext'
import { IResourceRecord } from '~/client/src/shared/resources/definitions/types'

import { useMobileResourceState } from './context'

interface IMobileResourceEditRecordResult {
  isOpen: boolean
  activeRecordId: string | null
  selectedRecord: IResourceRecord | null
  editableRecord: ResourceEditRecord | null
  clearActiveRecord: () => void
}

export function useMobileResourceEditRecord(): IMobileResourceEditRecordResult {
  const { selectedRecordId, records } = useMobileResourceState()

  const isOpen = !!selectedRecordId
  const activeRecordIdRef = React.useRef<string | null>(null)
  const [, forceRender] = React.useReducer(count => count + 1, 0)

  if (selectedRecordId) {
    activeRecordIdRef.current = selectedRecordId
  }

  const clearActiveRecord = React.useCallback(() => {
    if (!activeRecordIdRef.current) return
    activeRecordIdRef.current = null
    forceRender()
  }, [])

  const activeRecordId = isOpen ? selectedRecordId : activeRecordIdRef.current

  const selectedRecord = React.useMemo(() => {
    if (!activeRecordId) return null
    return records.find(record => record.id === activeRecordId) || null
  }, [activeRecordId, records])

  const editableRecord = React.useMemo(() => {
    if (!selectedRecord) return null
    return {
      ...selectedRecord,
      code: selectedRecord.code ?? null,
      isDeleted: selectedRecord.isDeleted ?? false,
      templateId: selectedRecord.templateId ?? null,
    }
  }, [selectedRecord])

  return {
    isOpen,
    activeRecordId,
    selectedRecord,
    editableRecord,
    clearActiveRecord,
  }
}
